(ns common.schema.entities.risk.schema
  (:require
   [common.schema.entities.common :as common]
   [common.schema.schema-utils :as su]
   [common.schema.entities.related-entities :as related-entities]))

(defn reverse-attribute
  [risk-entity]
  (case (:entity/type risk-entity)
    :entity.type/risk-holding :holding/_risks))

(def schema
  (concat
   (su/text-simple-field :risk/title
                         "Title"
                         {:authorization            su/access-user-user
                          :not-clearable?           true
                          :mandatory-config         :mandatory/always
                          :system-required?         true
                          :system-semantics
                          su/user-provided-system-required-field-semantics
                          :default-field-visibility :in-use-disabled})
   (su/option-field :risk/status
                    "Status"
                    {:authorization            su/access-user-user
                     :not-clearable?           true
                     :mandatory-config         :mandatory/always
                     :system-required?         true
                     :system-semantics
                     su/user-provided-system-required-field-semantics
                     :default-field-visibility :in-use-disabled})
   (su/option-field :risk/severity
                    "Severity"
                    {:authorization su/access-user-user
                     :default-field-visibility :in-use})
   (su/text-multiline-field :risk/description
                            "Description"
                            {:authorization su/access-user-user
                             :default-field-visibility :in-use})
   (su/text-multiline-field :risk/mitigation
                            "Mitigation"
                            {:authorization su/access-user-user
                             :default-field-visibility :in-use})
   (su/calculated-field :risk/primary-entity
                        "Primary entity"
                        {:authorization su/access-user-user
                         :calc-fn       (constantly nil)
                         :data-type     :data.type/ref-single
                         :default-field-visibility :not-in-use-blocked})
   related-entities/related-entities
   common/attachment-schema))
